import codes from './codes'; 

let newCodes = []
Object.keys(codes).map((code) => {
  codes[code].iso = code
  newCodes.push(codes[code])
})
 
export function getCountryCodes(only) {
  if (!Array.isArray(only)) {
    return newCodes;
  }

  let toReturn = [];
  
  only.map(function(iso) {
    if (codes[iso]) {
      codes[iso].iso = iso;
      toReturn.push(codes[iso]);
    }
  });

  return toReturn;
}

export function getCountryISO(num){
  let countryISO;
  newCodes.map((code) => {
    if(code.code == num){
      countryISO = code
    }
  })

  return countryISO
}

//
// Return single country code object by iso code
// 
// @param {string} iso           - iso code such as UK, CA, US ...
// @return {object} country      -
// @return {string} country.name - full name of a country
// @return {string} country.code - calling code of the country
// @return {string} country.iso  - iso of the country.
//
export function getCountryCodeByISO(iso) {

  if (!codes[iso]) {
    throw new Error(`No country found by iso ${iso}`);
    return;
  }

  codes[iso].iso = iso;

  return codes[iso];
}






// WEBPACK FOOTER //
// ./src/util/countryCode/index.js